import { connect, ConnectedProps } from 'react-redux';
import { selectIsRebalanceDataSourceTriumph } from 'src/store/selectors';
import { RootState } from '../../../../reducers';
import { selectAfsls } from '../../common/store/selectors';
import { Filters } from './components/filters';
import { selectModels, selectParameters, selectSecurities } from './store/selectors';
import { searchSlice } from './store/slice';
import { fetchModels, fetchResults } from './store/thunks';

const mapStateToProps = (state: RootState) => ({
  afsls: selectAfsls(state),
  models: selectModels(state),
  securities: selectSecurities(state),
  parameters: selectParameters(state),
  isRebalanceDataSourceTriumph: selectIsRebalanceDataSourceTriumph(state),
  isLoading: false,
  hasErrors: false,
});

const mapDispatchToProps = {
  ...searchSlice.actions,
  fetchResults,
  fetchModels,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = ConnectedProps<typeof connector>;
export const OrderSearchFiltersContainer = connector(Filters);
